{
    "Accessibility menu": "Menu de acessibilidade",
    "Close": "Fechar",
    "Text and Reading": "Texto e leitura",
    "Navigation and Interaction": "Navegação e interação",
    "Text Align": "Alinhamento do texto",
    "Align Left": "Alinhar à esquerda",
    "Align Center": "Centralizar",
    "Align Right": "Alinhar à direita",
    "Adjust Font Size": "Ajustar Tamanho da Fonte",
    "Highlight Title": "Destacar Título",
    "Highlight Links": "Destacar Links",
    "Readable Font": "Fonte Legível",
    "Color and Contrast": "Cor e contraste",
    "Dark Contrast": "Contraste Escuro",
    "Light Contrast": "Contraste Claro",
    "High Contrast": "Alto Contraste",
    "High Saturation": "Alta Saturação",
    "Low Saturation": "Baixa Saturação",
    "Monochrome": "Monocromático",
    "Tools": "Ferramentas",
    "Reading Guide": "Guia de Leitura",
    "Big Cursor": "Cursor Grande",
    "Increase Font Size": "Aumentar Tamanho da Fonte",
    "Decrease Font Size": "Diminuir Tamanho da Fonte",
    "Letter Spacing": "Espaçamento entre Letras",
    "Line Height": "Altura da Linha",
    "Font Weight": "Peso da Fonte",
    "Dyslexia Font": "Fonte para Dislexia",
    "Language": "Idioma",
    "Accessibility widget": "Abrir menu de acessibilidade",
    "Accessibility Profiles": "Perfis de Acessibilidade",
    "Cognitive Disability": "Deficiência Cognitiva",
    "Seizure Safe": "Seguro para Epilepsia",
    "Accessibility statement": "Declaração de Acessibilidade",
    "ADHD": "TDAH",
    "Low Vision": "Baixa visão",
    "Pause Animations": "Parar Animações",
    "Animation paused": "Animação pausada",
    "Reset all settings": "Redefinir configurações",
    "Shortcut:": "Atalho:",
    "Epilepsy Safe Mode": "Modo seguro para epilepsia",
    "Mute sounds": "Silenciar sons",
    "Page read": "Leitura da página",
    "Page read controls": "Controles de leitura",
    "Pause": "Pausar",
    "Resume": "Retomar",
    "Stop": "Parar",
    "Settings": "Configurações",
    "Speed": "Velocidade",
    "Voice": "Voz",
    "Close accessibility menu": "Fechar o menu de acessibilidade",
    "Back to accessibility menu": "Voltar ao menu de acessibilidade",
    "Search languages": "Pesquisar idiomas",
    "Selected language": "Idioma selecionado",
    "View accessibility statement (opens in new window)": "Ver a declaração de acessibilidade (abre em uma nova janela)",
    "Visit CookieYes website (opens in new window)": "Visitar o site da CookieYes (abre em uma nova janela)",
    "Reset all accessibility settings to default": "Redefinir todas as configurações de acessibilidade"
}
